<template>
    <v-container class="fill-height dark">
        <v-row>
            <v-col cols="7">
                <v-img max-width="150" src="@/assets/logo_stf_transparent_black.png"></v-img>
                <h1 class="text-h1 my-4 font-weight-bold" style="font-size:2.4em;">SEO Team Flow</h1>
                <h2 class="text-h2 mt-4 font-weight-bold mb-12">SEO that flows</h2>

                <v-container style="position: absolute; top:65vh;">
                    <a href="/signup">
                        <v-btn size="x-large" variant="outlined" class="text-yellow text-uppercase my-4" @click="navigateToSignup">
                                Try for free
                        </v-btn>
                    </a>
                    <p class="my-4" style="font-size:1.5em;">Have an Account? <a href="#">Log in</a></p>
                </v-container>
            </v-col>
            <v-col cols="5">
                <v-img width="100%" max-width="700" src="@/assets/splash.png"></v-img>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: "splash",
    methods: {
        navigateToSignup() {
            this.$router.push("/sign-up-stepper");
        }
    }
}
</script>
